import { zeusApi } from 'src/store/api';
import { type Holding, type HoldingLimits } from 'src/shared/types/holding';

const extendedApi = zeusApi.injectEndpoints({
  endpoints: build => ({
    getUserHolding: build.query<Holding, void>({
      query: () => ({
        url: `/holding`,
        method: 'GET',
        providesTags: ['UserHolding']
      })
    }),
    getUserHoldingLimits: build.query<HoldingLimits, void>({
      providesTags: ['Limits'],
      query: () => ({
        url: `/holding/limits`,
        method: 'GET'
      })
    })
  }),
  overrideExisting: false
});

export const { useGetUserHoldingQuery, useGetUserHoldingLimitsQuery, useLazyGetUserHoldingQuery } = extendedApi;
